export default __webpack_public_path__ + "static/media/asoulforourfeast2.e1dee647.png";